import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  action: "insert",

  contrNo: null,
  SEQ: null,
  sprName: null,
  quotNo: null,
  cat: "1",
  AOSQuotNo: null,
  paytNo: null,
  paytDescr: null,
  costExclVAT: null,
  costInclVAT: null,
  invNo: null,
  invPlan: null,
  invPlanedDate: null,
  invDate: null,
  paytTerm: null,
  paytPlanedDate: null,
  paytDate: null,
  workStartYearMonth: null,
  workEndYearMonth: null,
  projComplDate: null,
  status: "5",

  comment: null,

  updateFields: [],
};

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    updateAction: (state, action) => {
      return {
        ...state,
        action: action.payload.action,
      };
    },

    updateAll: (state, action) => {
      return { ...action.payload, updateFields: [] };
    },

    updateBasicInfo: (state, action) => {
      return {
        ...state,
        contrNo: action.payload.contrNo,
        sprName: action.payload.sprName,
        // projName : action.payload.projName,
        quotNo: action.payload.quotNo,
        // updateFields: [...state.updateFields, "contrNo", "sprName", "quotNo"],
        updateFields: [...state.updateFields, "contrNo", "quotNo"],
      };
    },

    updateContrNo: (state, action) => {
      return {
        ...state,
        contrNo: action.payload.contrNo,
        updateFields: [...state.updateFields, "contrNo"],
      };
    },

    updateSprName: (state, action) => {
      return {
        ...state,
        sprName: action.payload.sprName,
        // updateFields: [...state.updateFields, "sprName"],
      };
    },

    updateQuotNo: (state, action) => {
      return {
        ...state,
        quotNo: action.payload.quotNo,
        updateFields: [...state.updateFields, "quotNo"],
      };
    },

    updateCat: (state, action) => {
      return {
        ...state,
        cat: action.payload.cat,
        updateFields: [...state.updateFields, "cat"],
      };
    },

    updateAOSQuotNo: (state, action) => {
      return {
        ...state,
        AOSQuotNo: action.payload.AOSQuotNo,
        updateFields: [...state.updateFields, "AOSQuotNo"],
      };
    },

    updatePaytNo: (state, action) => {
      return {
        ...state,
        paytNo: action.payload.paytNo,
        updateFields: [...state.updateFields, "paytNo"],
      };
    },

    updatePaytDescr: (state, action) => {
      return {
        ...state,
        paytDescr: action.payload.paytDescr,
        updateFields: [...state.updateFields, "paytDescr"],
      };
    },

    updateCost: (state, action) => {
      return {
        ...state,
        costExclVAT: action.payload.costExclVAT,
        costInclVAT: action.payload.costExclVAT * 1.1,
        updateFields: [...state.updateFields, "costExclVAT"],
      };
    },

    updateInvNo: (state, action) => {
      return {
        ...state,
        invNo: action.payload.invNo,
        updateFields: [...state.updateFields, "invNo"],
      };
    },

    updateInvPlan: (state, action) => {
      return {
        ...state,
        invPlan: action.payload.invPlan,
        updateFields: [...state.updateFields, "invPlan"],
      };
    },

    updateInvPlanedDate: (state, action) => {
      return {
        ...state,
        invPlanedDate: action.payload.invPlanedDate,
        updateFields: [...state.updateFields, "invPlanedDate"],
      };
    },

    updateInvDate: (state, action) => {
      return {
        ...state,
        invDate: action.payload.invDate,
        updateFields: [...state.updateFields, "invDate"],
      };
    },

    updatePaytTerm: (state, action) => {
      return {
        ...state,
        paytTerm: action.payload.paytTerm,
        updateFields: [...state.updateFields, "paytTerm"],
      };
    },

    updatePaytPlanedDate: (state, action) => {
      return {
        ...state,
        paytPlanedDate: action.payload.paytPlanedDate,
        updateFields: [...state.updateFields, "paytPlanedDate"],
      };
    },

    updatePaytDate: (state, action) => {
      return {
        ...state,
        paytDate: action.payload.paytDate,
        updateFields: [...state.updateFields, "paytDate"],
      };
    },

    updateWorkStartYearMonth: (state, action) => {
      return {
        ...state,
        workStartYearMonth: action.payload.workStartYearMonth,
        updateFields: [...state.updateFields, "workStartYearMonth"],
      };
    },

    updateWorkEndYearMonth: (state, action) => {
      return {
        ...state,
        workEndYearMonth: action.payload.workEndYearMonth,
        updateFields: [...state.updateFields, "workEndYearMonth"],
      };
    },

    init: (state, action) => {
      return {
        ...initialState,
      };
    },

    updateProjComplDate: (state, action) => {
      return {
        ...state,
        projComplDate: action.payload.projComplDate,
        updateFields: [...state.updateFields, "projComplDate"],
      };
    },

    updateTaskComplDate: (state, action) => {
      return {
        ...state,
        taskComplDate: action.payload.taskComplDate,
        updateFields: [...state.updateFields, "taskComplDate"],
      };
    },

    updateComment: (state, action) => {
      return {
        ...state,
        comment: action.payload.comment,
        updateFields: [...state.updateFields, "comment"],
      };
    },

    updateStatus: (state, action) => {
      return {
        ...state,
        status: action.payload.status,
        updateFields: [...state.updateFields, "status"],
      };
    },
  },
});

export const {
  updateAll,
  updateBasicInfo,
  updateContrNo,
  updateSprName,
  updateQuotNo,
  updateCat,
  updateAOSQuotNo,
  updatePaytNo,
  updatePaytDescr,
  updateCost,
  updateInvNo,
  updateInvPlan,
  updateInvPlanedDate,
  updateInvDate,
  updatePaytTerm,
  updatePaytPlanedDate,
  updatePaytDate,
  updateWorkStartYearMonth,
  updateWorkEndYearMonth,
  init,
  updateProjComplDate,
  updateComment,
  updateTaskComplDate,
  updateStatus,
} = paymentSlice.actions;

export default paymentSlice.reducer;
